import Vue from 'vue'
import Router from 'vue-router'

// import Layout from "../views/Layout";

import Question from "../views/Question";
import Rank from "../views/Rank";
import Login from "../views/Login/login";
import errorPage from "../views/ErrorPage/404"



const routerPush = Router.prototype.push;
Router.prototype.push = function push(location, onComplete, onAbort) {
    return routerPush.call(this, location, onComplete, onAbort).catch((error) => error);
};

Vue.use(Router)

export const constantRouterMap = [
  //   {
  //       path:"/",
  //       component: Login,
  //   },
  // {
  //   path:"/question",
  //   component: Question,
  // },
  {
    path:"/",
    component: Question,
  },
    {
        path:"/rank",
        component: Rank,
    },
    // {
    //     path: "/student",
    //     redirect: "/student/exam/start",
    //     component:Student,
    //     children: [
    //         { path: "/student/exam/start", component: ExamStart, title: "模拟考试" },
    //         { path: "/student/exam/question", component: ExamQuestion, title: "模拟考试" },
    //         { path: "/student/exam/kemu1", component: Kemu1, title: "科目一" },
    //         { path: "/student/exam/kemu2", component: Kemu2, title: "科目二" },
    //     ],
    // },
    // {
    //     path: "/bigScreen",
    //     redirect: "/bigScreen/BigP1",
    //     component:bigScreen,
    //     children: [
    //         { path: "/bigScreen/BigP1", component: BigP1, title: "p1-人数" },
    //         { path: "/bigScreen/BigP2", component: BigP2, title: "p2-分布" },
    //         { path: "/bigScreen/BigP3", component: BigP3, title: "p3-基地" },
    //         { path: "/bigScreen/BigP4", component: BigP4, title: "p4-课程" },
    //         { path: "/bigScreen/BigP5", component: BigP5, title: "p5-个人" },
    //     ],
    // },
    // { path: "*", component: "errorPage", hidden: true }
]
export default new Router({
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap,
    fallback: false,
});



// WEBPACK FOOTER //
// ./src/router/index.js